import { Injectable, inject } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DisparoAutomaticoModel} from '../model/disparo-automatico/disparo-automatico.model';
import { PageModel } from '../model/page-mode.model';
import { LogRotina } from '../model/log-rotina.model';
import {DisparoAutomaticoFiltro} from '../model/disparo-automatico/disparo-automatico-filtro.model';

@Injectable({
  providedIn: 'root'
})
export class DisparoAutomaticoService {

  private readonly http = inject(HttpClient);

  private urlBase = `${environment.urlBase}`;

  salvarDisparoAutomarico(disparoAutomatico: DisparoAutomaticoModel): Observable<number> {
    return this.http.post<number>(`${this.urlBase}/disparo-automatico`, disparoAutomatico);
  }

  alterarStatusDisparoAutomatico(status: string, disparoAutomaticoId: number): Observable<any> {
    return this.http.patch(`${this.urlBase}/disparo-automatico/alterar-status`, { id: disparoAutomaticoId, status: status });
  }

  pausarDisparo(disparoId: number): Observable<string> {
    return this.http.patch<string>(`${this.urlBase}/disparo-automatico/${disparoId}/pausar`, {});
  }

  despausarDisparo(disparoId: number): Observable<string> {
    return this.http.patch<string>(`${this.urlBase}/disparo-automatico/${disparoId}/despausar`, {});
  }

  buscarDisparosAutomaticos(
    page: number,
    limit: number,
    statusGroup: 'DISPAROS' | 'PROGRAMACOES' = 'DISPAROS',
    programacaoId?: number,
    filtro: DisparoAutomaticoFiltro = new DisparoAutomaticoFiltro()
  ): Observable<PageModel> {
    let params = new HttpParams()
      .set('page', page)
      .set('limit', limit)
      .set('statusGroup', statusGroup);

    if (programacaoId != null) {
      params = params.set('programacaoId', programacaoId);
    }

    return this.http.post<PageModel>(
      `${this.urlBase}/disparo-automatico/buscar`,
      DisparoAutomaticoFiltro.payload(filtro),
      { params }
    );
  }

  buscarLogsDisparosAutomaticos(disparoId: number): Observable<LogRotina[]> {
    return this.http.get<LogRotina[]>(`${this.urlBase}/disparo-automatico/buscar-logs-disparos/${disparoId}`);
  }

  buscarDisparo(disparoId: number): Observable<DisparoAutomaticoModel> {
    return this.http.get<DisparoAutomaticoModel>(`${this.urlBase}/disparo-automatico/${disparoId}`);
  }

  buscarContatosPorDisparo(disparoId: number, page: number, size: number): Observable<any> {
    return this.http.get(`${this.urlBase}/disparo-automatico/${disparoId}/contatos`, {
      params: {
        page,
        size
      }
    });
  }

  buscarDisparoPorUuid(uuid: string): Observable<DisparoAutomaticoModel> {
    return this.http.get<DisparoAutomaticoModel>(`${this.urlBase}/disparo-automatico/uuid/${uuid}`);
  }

  reenviarFalhasIntegracao(disparoId: number): Observable<number> {
    return this.http.post<number>(
      `${this.urlBase}/disparo-automatico/${disparoId}/integracao/reenviar-falhas`,
      {}
    );
  }
}
